import ModalRedirectToPageWizard from "./modalRedirectToPageWizard";
import { TILDA_PATHS } from "../../../../shared/constants";

interface IModalTradeInProps {
  isOpen: boolean;
  onDismiss: (value: boolean) => void;
  offsetY: number;
}

const TEXT_BUY =
  "Перейдите к оформлению заявки и мы поможем подобрать вам жилье на выгодных условиях.";

const TITLE_BUY = "Помощь в покупке";

const ModalRedirectToPageWizardBuy = ({
  isOpen,
  offsetY,
  onDismiss,
}: IModalTradeInProps) => {
  const handleRedirect = () => {
    window.open(TILDA_PATHS.reitInvest.buy, "_blank");
  };

  return (
    <ModalRedirectToPageWizard
      offsetY={offsetY}
      title={TITLE_BUY}
      text={TEXT_BUY}
      onRedirect={handleRedirect}
      onDismiss={onDismiss}
      isOpen={isOpen}
    />
  );
};
export default ModalRedirectToPageWizardBuy;
